/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForSaas extends models.ServiceAccountNativeDetailsBaseForSaas {
    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForSaas.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForSaas>): ServiceAccountNativeDetailsForSaas {
        let obj = Object.assign(new ServiceAccountNativeDetailsForSaas(), model);
        ServiceAccountNativeDetailsForSaas.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForSaas>): ServiceAccountNativeDetailsForSaas {
        if (!model) return null;
        return ServiceAccountNativeDetailsForSaas.newInstance(<ServiceAccountNativeDetailsForSaas> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForSaas) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForSaas.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForSaas): boolean {
        if (models.ServiceAccountNativeDetailsBaseForSaas.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForSaas.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.storage) {
            models.StorageConfigurationBaseForSaas.fixupPrototype(this.storage);
        }
    }

    /**
     * Name of the SaaS Application.
     */
    application_name: string;

    storage: models.StorageConfigurationBaseForSaas;

}
